// extracted by css-extract-rspack-plugin
export default {"page":"AmbassadorV2-module__page"};